module.exports = __webpack_public_path__ + "static/media/scalpel.0221551f.svg";